import { AfterViewInit, Component, OnInit, ViewChild } from "@angular/core";
import {
  MatTableDataSource,
  MatPaginator,
  MatDatepickerInputEvent,
  MatSort,
} from "@angular/material";
import { AppService } from "src/_services/app.service";
import { Router } from "@angular/router";
import { User } from "src/_models";
import * as moment from "moment";
import { SapRoles } from "src/_constants/roleType";
import { FormControl } from "@angular/forms";
import { Category } from "src/_models/bet";

@Component({
  selector: "app-pl-statment",
  templateUrl: "./pl-statment.component.html",
  styleUrls: ["./pl-statment.component.scss"],
})
export class PLStatmentComponent implements OnInit, AfterViewInit {
  @ViewChild(MatSort) sort: MatSort;
  datalistDisplayedColumns: string[] = [
    "sport_name",
    "ProviderId",
    "profit_loss",
  ];
  selected: any = {
    startDate: new Date().setHours(0, 0, 0, 0),
    endDate:
      new Date().setHours(23, 59, 59),
  };
  startOfDay = moment().subtract(1, "days").startOf("day");
  endOfDay = moment().subtract(1, "days").endOf("day");
  ranges: any = {
    Today: [moment().startOf("day"), moment()],
    Yesterday: [
      moment(this.startOfDay),

      moment(this.endOfDay),
    ],
    "Last 7 Days": [
      moment(moment().subtract(6, "days").startOf("day")),
      moment(),
    ],
    "Last 30 Days": [
      moment(moment().subtract(29, "days").startOf("day")),
      moment(),
    ],
    "This Month": [moment().startOf("month"), moment()],
    "Last Month": [
      moment().subtract(1, "month").startOf("month"),
      moment().subtract(1, "month").endOf("month"),
    ],
  };
  userRole: any = JSON.parse(sessionStorage.getItem("currentUser"));
  providers: any = JSON.parse(sessionStorage.getItem("category"));
  datalist = new MatTableDataSource<any>();
  ProviderId = new FormControl([]);
  showAlert: any = false;
  selectedUser: { userId: string; userName: string };
  length: any = 0;
  page = 1;
  pageSize = 10;
  OperatorId = new FormControl([]);
  sapRoles = SapRoles;
  operatorData = [];
  pageEvent: any = { pageIndex: 1, pageSize: 0, length: 0 };
  isAdmin: boolean;
  exchangeProfit: number = 0;
  sportsBookProfit: number = 0;
  dropdownSettings: any = {};
  operatorSettings: any = {};
  statusSettings: any = {};
  originSettings: any = {};
  origin = new FormControl([]);
  category = new FormControl([]);
  origins = ["SPORTSBOOK","PREMIUM","VIRTUAL","EXPREMIUM"];
  categories = Category;
  subProviders = ["TPremium"];
  subProvider = new FormControl([]);

  constructor(private appService: AppService, private router: Router) {}

  ngOnInit() {
    this.dropdownSettings = {
      singleSelection: true,
      idField: "item_id",
      textField: "item_text",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      itemsShowLimit: 1,
      allowSearchFilter: true,
    };
    this.operatorSettings = {
      singleSelection: true,
      idField: "operator_id",
      textField: "operator_id",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      itemsShowLimit: 1,
      allowSearchFilter: true,
    };
    this.statusSettings = {
      singleSelection: true,
      idField: "id",
      textField: "name",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      itemsShowLimit: 1,
      allowSearchFilter: true,
    };
    this.originSettings = {
      singleSelection: false,
      idField: "id",
      textField: "name",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      itemsShowLimit: 1,
      allowSearchFilter: true,
    };
    this.isAdmin = [this.sapRoles.SAPAdmin, this.sapRoles.RiskAdmin].includes(this.userRole.role);
    // this.getOurProviders();
   this.getAdminProviders();
    this.getOperatorData();
    console.log("userRole", this.userRole.operatorId);
  }

  ngAfterViewInit() {
    this.datalist.sort = this.sort;
    this.datalist.sortingDataAccessor = (item, property) => {
      switch (property) {
        case 'profit_loss': return item.profitLoss;
        case 'sport_name': return item.sportName;
        default: return item[property];
      }
    };
  }

  @ViewChild(MatPaginator) paginator: MatPaginator;

  getOurProviders() {
    try {
      this.appService.getOurProviders().subscribe((res) => {
        if (res.status === "RS_OK") {
          this.providers = res.providers;
        } else {
          if (res.errorDescription === "Invalid Token!") {
            sessionStorage.clear();
            this.router.navigateByUrl("/login");
          }
        }
      });
    } catch (err) {}
  }

  getAdminProviders(){
    if (this.userRole.role === this.sapRoles.SAPAdmin || 
      this.userRole.role === this.sapRoles.SAPUser ||
      this.userRole.role === this.sapRoles.RiskAdmin){
        this.providers = ["Exchange","SportsBook"];
    }
    this.onSelectedProvider(this.providers[0]);
  }

  calculateOverall() {
    return this.exchangeProfit + this.sportsBookProfit;
  }

  getName() {
    return this.isAdmin && this.OperatorId.value.length !== 0 && this.OperatorId.value[0].operator_id === "all"
      ? "House"
      : this.isAdmin && this.OperatorId.value.length !== 0 && this.OperatorId.value[0].operator_id !== "all"
      ? this.OperatorId.value[0].operator_id
      : "";
  }

  onSelectedOperatorId = (OperatorId) => {
    this.page = 1;
    this.OperatorId.setValue([OperatorId[0].operator_id]);
    this.getReportData();
    this.paginator.pageIndex = 0;
  };

  getOperatorData() {
    try {
      this.appService.getOperatorId().subscribe((res) => {
        if (res.status === "RS_OK") {
          this.operatorData = res.operators.sort((a, b) => {
            let fa = a.operator_id.toLowerCase(),
              fb = b.operator_id.toLowerCase();

            if (fa < fb) {
              return -1;
            }
            if (fa > fb) {
              return 1;
            }
            return 0;
          });
        } else {
          if (res.errorDescription === "Invalid Token!") {
            sessionStorage.clear();
            this.router.navigateByUrl("/login");
          }
        }
      });
    } catch (err) {}
  }

  goToComponentSport(data): void {
    this.router.navigate([`reports/pl-statment/${data.sportId}`], {
      queryParams: {
        providerId: data.providerId,
        userName: this.selectedUser ? this.selectedUser.userName : null,
        userId: this.selectedUser ? this.selectedUser.userId : null,
        origin: this.origin.value.length != 0 ? this.origin.value : [],
        category: this.category.value.length != 0 ? this.category.value[0].id : "",
        subProvider: this.subProvider.value.length != 0 ? this.subProvider.value[0] : "",
        operatorId: this.OperatorId.value.length === 0 ? "" : this.OperatorId.value[0],
        sportId: data.sportId,
        startTime:
          this.selected.startDate !== null
            ?  Math.floor(new Date(this.selected.startDate).getTime() / 1000)
            : 0,
        endTime:
          this.selected.endDate !== null
            ?  Math.floor(new Date(this.selected.endDate).getTime() / 1000)
            : 0,
      },
    });
  }

  goToComponentProvider() {
    this.router.navigate(["/reports/pl-statment"]);
  }

  onSelectedProvider = (pid) => {
    this.ProviderId.setValue([pid]);
    this.getReportData();
  };

  onDateChangeHandler = (event: MatDatepickerInputEvent<Date>) => {
    this.selected = event;
    if (this.selected.endDate) {
      let start = this.selected.startDate;
      let end = this.selected.endDate;
      let diff = end.diff(start, "days") + 1;
      if (diff > 35) {
        this.showAlert = true;
        this.selected.startDate = moment(new Date().setHours(0, 0, 0, 0));
        this.selected.endDate = moment(new Date().setHours(23, 59, 59));
        setTimeout(() => {
          this.showAlert = false;
        }, 5000);
      } else if (this.selected.startDate !== null) {
        this.getReportData();
      }
    }
  };

  onUserSelection(event: any) {
    // console.log("user", event);
    this.selectedUser = event;
    this.getReportData();
  }

  onUserSelectionClear() {
    this.selectedUser = null;
    this.getReportData();
  }

  changePagination(event: Event) {
    this.pageEvent = event;
    this.pageSize = this.pageEvent.pageSize;
    this.page = this.pageEvent.pageIndex + 1;
    this.getReportData();
  }

  getReportData = () => {
    if (this.ProviderId.value[0] !== "all") {
      try {
        let filters = {
          providerId: this.ProviderId.value[0],
          origin: this.origin.value.length != 0 ? this.origin.value : [],
          category: this.category.value.length != 0 ? this.category.value[0].id : "",
          subProvider: this.subProvider.value.length != 0 ? this.subProvider.value[0] : "",
          startTime:
            this.selected.startDate !== null
              ?  Math.floor(new Date(this.selected.startDate).getTime() / 1000)
              : 0,
          endTime:
            this.selected.endDate !== null
              ?  Math.floor(new Date(this.selected.endDate).getTime() / 1000)
              : 0,
          userId: this.selectedUser ? this.selectedUser.userId : null,
          operatorId: this.OperatorId.value.length === 0  ? "" : this.OperatorId.value[0],
          pageSize: this.pageSize,
          page: this.page,
        };

        this.appService.getPLData(filters).subscribe((res) => {
          if (res.status === "RS_OK") {
            this.datalist.data = res.providerPnLReport;
            this.length = res.totalBets;
            this.datalist.paginator = this.paginator;
            if (this.ProviderId.value[0] === "Exchange") {
              this.exchangeProfit =
                -1 *
                res.providerPnLReport.reduce((accumulator, currentValue) => {
                  return accumulator + currentValue.profitLoss;
                }, 0);
            } else if (this.ProviderId.value[0] === "SportsBook") {
              this.sportsBookProfit =
                -1 *
                res.providerPnLReport.reduce((accumulator, currentValue) => {
                  return accumulator + currentValue.profitLoss;
                }, 0);
            }
          }
        });

        if (this.ProviderId.value[0] === "Exchange") {
          filters.providerId = "SportsBook";
          this.appService.getPLData(filters).subscribe((res) => {
            if (res.status === "RS_OK") {
              this.sportsBookProfit =
                -1 *
                res.providerPnLReport.reduce((accumulator, currentValue) => {
                  return accumulator + currentValue.profitLoss;
                }, 0);
            }
          });
        } else if (this.ProviderId.value[0] === "SportsBook") {
          filters.providerId = "Exchange";
          this.appService.getPLData(filters).subscribe((res) => {
            if (res.status === "RS_OK") {
              this.exchangeProfit =
                -1 *
                res.providerPnLReport.reduce((accumulator, currentValue) => {
                  return accumulator + currentValue.profitLoss;
                }, 0);
            }
          });
        }
      } catch (err) {}
    }
  };
}
